import { FormFieldTypes } from "../../../data/formFieldType";
import PasswordModel from "../component/ResetPassword/PasswordModel";

export const EditGMPCourseData = {
    name: "EditGMPCourseData",
    initialState: {
        organisationName: '',
        UENNumber: "",
        mailingAddress1: "",
        mailingAddress2: "",
        country: null,
        postalCode: "",
        organisationWebsite: "",
        organisationLogo: "",
        shortDescriptionofOrganisation: "",
        organizationfalls: "no",
        nameofRepresentative: "",
        emailAddress: "",
        contactNumber: "",
        alternateNameOfRepresentative: "",
        alternateEmailAddress: "",
        alternateContactNumber: "",
    },

    formFields: [
        {
            id: "applicantOrganisationProfile",
            lable: "",
            Field_Name: "personalParticularstitle",
            fieldType: FormFieldTypes.MAINFORMTITLE,
            dataField: "applicantOrganisationProfile",
            fieldSetting: {
                formTitle: "Applicant Organisation Profile",
            },
            style: {
                containerCss: "col-lg-12 mb-2 text-left form-title",
            },
        },
        {
            id: "organisationName",
            lable: "Organisation Name",
            Field_Name: "Organisation Name",
            fieldType: FormFieldTypes.INPUT,
            dataField: "organisationName",
            fieldSetting: {
                placeholder: "",
                allowSpace: true,
            },
            validation: [ { type: "require" } ],
            style: {
                containerCss: "col-md-6 mb-3",
            },
        },
        {
            id: "UENNumber",
            lable: "UEN Number",
            Field_Name: "UEN Number",
            fieldType: FormFieldTypes.INPUT,
            dataField: "UENNumber",
            fieldSetting: {
                placeholder: "",
                allowSpace: false,
            },
            validation: [ { type: "require" } ],
            style: {
                containerCss: "col-md-6 mb-3",
            },
        },
        {
            id: "mailingAddress1",
            lable: "Mailing Address Line 1 ",
            Field_Name: "Mailing Address Line 1 ",
            fieldType: FormFieldTypes.INPUT,
            dataField: "mailingAddress1",
            fieldSetting: {
                placeholder: "",
                allowSpace: true,
            },
            validation: [ { type: "require" } ],
            style: {
                containerCss: "col-md-6 mb-3",
            },
        },
        {
            id: "mailingAddress2",
            lable: "Mailing Address Line 2",
            Field_Name: "Mailing Address Line 2 ",
            fieldType: FormFieldTypes.INPUT,
            dataField: "mailingAddress2",
            fieldSetting: {
                placeholder: "",
                allowSpace: true,
            },
            // validation: [{ type: "require" }],
            style: {
                containerCss: "col-md-6 mb-3",
            },
        },
        {
            id: "country",
            lable: "Country",
            Field_Name: "Country",
            fieldType: FormFieldTypes.SELECT,
            dataField: "country",
            fieldSetting: {
                placeholder: "",
                options: [],
            },
            validation: [ { type: "require" } ],
            style: {
                containerCss: "col-md-6 mb-2",
            },
        },
        {
            id: "postalCode",
            lable: "Postal Code",
            Field_Name: "Postal Code",
            fieldType: FormFieldTypes.NUMERIC,
            dataField: "postalCode",
            fieldSetting: {
                placeholder: "",
                allowSpace: false,
            },
            validation: [ { type: "require" } ],
            style: {
                containerCss: "col-md-6 mb-2",
            },
        },
        {
            id: "organisationWebsite",
            lable: "Organisation Website",
            Field_Name: "Organisation Website ",
            fieldType: FormFieldTypes.INPUT,
            dataField: "organisationWebsite",
            fieldSetting: {
                placeholder: "",
                allowSpace: false,
            },
            validation: [ { type: "require" } ],
            style: {
                containerCss: "col-md-6 mb-3",
            },
        },
        {
            id: "organisationLogo",
            lable: "Organisation Logo (please upload in jpg/png format max 2mb)",
            Field_Name: "file",
            fieldType: FormFieldTypes.FILE,
            dataField: "organisationLogo",
            fieldSetting: {
                // presentFileName: null,
                placeholder: "",
                // isDownloadable: false,
                acceptedFiles: ".jpg, .png",
                imageCrop: true,
                viewImage: true,
                maxFileSizeInKB: 2048,
            },
            validation: [ { type: "require" } ],
            style: {
                containerCss: "col-md-6 mb-2",
            },
        },
        {
            id: "shortDescriptionofOrganisation",
            lable: "Short Description of Organisation",
            Field_Name: "Short Description of Organisation",
            fieldType: FormFieldTypes.TEXTAREA,
            dataField: "shortDescriptionofOrganisation",
            fieldSetting: {
                placeholder: "",
                allowSpace: true,
                maxWords: 100,
            },
            validation: [ { type: "require" } ],
            style: {
                containerCss: "col-md-12 mb-2",
            },
        },
        {
            fieldType: FormFieldTypes.SEPARATOR,
            style: {
                containerCss: "separation-line pl-0 pr-0",
            },
        },
        {
            id: "applicantRepresentativeDetails",
            lable: "Applicant Representative Details",
            Field_Name: "applicantRepresentativeDetails",
            fieldType: FormFieldTypes.MAINFORMTITLE,
            dataField: "applicantRepresentativeDetails",
            fieldSetting: {
                formTitle: "Applicant Representative Details",
            },
            style: {
                containerCss: "col-lg-12 mb-2 text-left  form-title",
            },
        },
        {
            id: "nameofRepresentative",
            lable: "Name of Representative",
            Field_Name: "Name of Representative",
            fieldType: FormFieldTypes.INPUT,
            dataField: "nameofRepresentative",
            fieldSetting: {
                placeholder: "",
                allowSpace: true,
            },
            validation: [ { type: "require" } ],
            style: {
                containerCss: "col-md-6 mb-3",
            },
        },
        {
            id: "emailAddress",
            lable: "Email Address",
            Field_Name: "Email Address",
            fieldType: FormFieldTypes.INPUT,
            dataField: "emailAddress",
            fieldSetting: {
                placeholder: "",
                allowSpace: false,
            },
            validation: [ { type: "require" } ],
            style: {
                containerCss: "col-md-6 mb-3",
            },
        },
        {
            id: "contactNumber",
            lable: "Contact Number",
            Field_Name: "Contact Number",
            fieldType: FormFieldTypes.NUMERIC,
            dataField: "contactNumber",
            fieldSetting: {
                placeholder: "",
                allowSpace: true,
            },
            validation: [ { type: "require" } ],
            style: {
                containerCss: "col-md-6 mb-2",
            },
        },
        {
            id: "resetPasswordforMain",
            fieldType: FormFieldTypes.COMPONENT,
            additionalComponent: <PasswordModel />,
            style: {
                containerCss: "col-md-6 mb-3",
            },
        },
        {
            fieldType: FormFieldTypes.SEPARATOR,
            style: {
                containerCss: "separation-border pl-0 pr-0 mb-2",
            },
        },
        // {
        //     id: "alternateNameOfRepresentative",
        //     lable: "Name of Alternate Representative",
        //     Field_Name: "Name of Alternate Representative",
        //     fieldType: FormFieldTypes.INPUT,
        //     dataField: "alternateNameOfRepresentative",
        //     fieldSetting: {
        //         placeholder: "",
        //         allowSpace: true,
        //     },
        //     // validation: [{ type: "require" }],
        //     style: {
        //         containerCss: "col-md-6 mb-3",
        //     },
        // },
        // {
        //     id: "alternateEmailAddress",
        //     lable: "Email Address",
        //     Field_Name: "Email Address",
        //     fieldType: FormFieldTypes.INPUT,
        //     dataField: "alternateEmailAddress",
        //     fieldSetting: {
        //         placeholder: "",
        //         allowSpace: false,
        //     },
        //     // validation: [{ type: "require" }],
        //     style: {
        //         containerCss: "col-md-6 mb-3",
        //     },
        // },
        // {
        //     id: "alternateContactNumber",
        //     lable: "Contact Number",
        //     Field_Name: "Contact Number",
        //     fieldType: FormFieldTypes.NUMERIC,
        //     dataField: "alternateContactNumber",
        //     fieldSetting: {
        //         placeholder: "",
        //         allowSpace: true,
        //     },
        //     // validation: [{ type: "require" }],
        //     style: {
        //         containerCss: "col-md-6 mb-2",
        //     },
        // },
    ],

    formSetting: {
        isViewOnly: false,
    },
};